<template>
  <div class="relative z-[10]">
    <transition
      enter-active-class="transition-all ease-out duration-200"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-all ease-in duration-200 delay-200"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <span
        v-if="props.open"
        class="fixed inset-0 inline-flex items-center justify-center bg-black bg-opacity-70"
      ></span>
    </transition>
    <transition
      enter-active-class="transition-all ease-in-out duration-300 transform delay-200"
      enter-from-class="opacity-0 -translate-y-[8px]"
      enter-to-class="opacity-100 -translate-y-0"
      leave-active-class="transition-all ease-in-out duration-300 transform"
      leave-from-class="opacity-100 -translate-y-0"
      leave-to-class="opacity-0 -translate-y-[8px]"
    >
      <div
        v-if="props.open"
        class="fixed inset-0 inline-flex items-center justify-center"
      >
        <div class="relative" :class="props.width">
          <button
            v-if="props.closeBtn"
            type="button"
            class="absolute right-[-15px] top-[-36px] flex h-[30px] w-[30px] items-center justify-center"
            @click="close"
          >
            <SvgIcon
              icon-class="close"
              class="h-[24px] w-[24px] fill-current text-white"
            />
          </button>
          <slot name="default" :close="close" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import { onKeyStroke } from '@vueuse/core'

export default {
  emits: ['update:open'],
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '',
    },
    closeFn: {
      type: Function,
      default: () => {},
    },
    closeBtn: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const close = () => {
      if (props.closeFn) {
        props.closeFn()
      }
      emit('update:open', false)
    }

    // onKeyStroke('Escape', () => {
    //   if (props.open) {
    //     close()
    //   }
    // })

    return { props, close }
  },
}
</script>
